// Menús
export const NOMBRE_MENU_VISITAS = 'Visitas verificación';
export const NOMBRE_MENU_MEDIOS_IMPRESOS = 'Medios impresos';
export const NOMBRE_MENU_INTERNET = 'Internet';
export const NOMBRE_MENU_ESPECTACULARES = 'Espectaculares';
export const NOMBRE_MENU_DESCARGAS = 'Descargas';
export const NOMBRE_MENU_GESTION_CONTENIDO = 'Gestión de contenido';

// Submenús
export const NOMBRE_SUBMENU_ACTAS_INICIO = 'Acta de inicio';
export const NOMBRE_SUBMENU_ACTAS_HALLAZGOS = 'Hallazgos';
export const NOMBRE_SUBMENU_ACTAS_CIERRE = 'Acta de cierre';
export const NOMBRE_SUBMENU_PROP_VIA_PUB = 'Propaganda en vía pública';
export const NOMBRE_SUBMENU_EVENTOS = 'Eventos';
export const NOMBRE_SUBMENU_CASAS = 'Casa de Campaña';
export const NOMBRE_MENU_CAT_MEDIOS_IMPRESOS = 'Catálogo de Medios impresos';
export const NOMBRE_SUBMENU_CAT_FECHAS = 'Catálogo de Fechas';
export const NOMBRE_SUBMENU_GEN_ENLACES = 'Generación de enlaces';

// Permisos
export const NOMBRE_MENU_PERMISO_CAPTURAR = 'Capturar';
export const NOMBRE_MENU_PERMISO_EDITAR = 'Editar';
export const NOMBRE_MENU_PERMISO_ELIMINAR = 'Eliminar';
export const NOMBRE_MENU_PERMISO_DESCARGAR = 'Descargar';
export const NOMBRE_MENU_PERMISO_QR = 'Qr';
export const NOMBRE_MENU_PERMISO_VALIDAR = 'Validar';
export const NOMBRE_MENU_PERMISO_NOTIFICAR = 'Check Notificar a Partido';
